(function () {
  document.querySelectorAll('[data-ss-installation]').forEach(function (section) {
    var dialog = section.querySelector('[data-ss-installation-dialog]');
    var openButtons = section.querySelectorAll('[data-ss-installation-open]');
    var closeBtn = section.querySelector('[data-ss-installation-close]');
    var video = section.querySelector('[data-ss-installation-video]');

    if (!dialog || openButtons.length === 0 || !video) return;

    function closeDialog() {
      video.pause();
      if (typeof dialog.close === 'function') {
        dialog.close();
      }
    }

    openButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        }
      });
    });

    closeBtn?.addEventListener('click', closeDialog);

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        closeDialog();
      }
    });

    dialog.addEventListener('close', function () {
      video.pause();
      video.currentTime = 0;
    });
  });
})();
